module.exports = __webpack_public_path__ + "img/taekwondo4.4104e477.jpg";